import { ButtonTypes } from "../../../../../../components/ui/Button";
import { Icon, IconSymbols } from "../../../../../../components/ui/Icon";
import { UiSizes } from "../../../../../../enums";
import I18n from "../../../../../localization/I18n";
import { UiActionRenderers } from "../../../../../uiAction/IUiAction";
import { GridActionEnum, GridLinkActionEnum } from "../../../enums/GridActionEnum";
import { ProjectStakeholdersGridModel } from "./ProjectStakeholdersGridView_model";

export const GetProjectStakeholdersGridActions = (model: ProjectStakeholdersGridModel) => {
  return [
    {
      id: GridActionEnum.add,
      label: I18n.t("phrases.add"),
      type: "uiAction",
      onAction: ev => model.showLinkStakeholderModal(),
      componentProps: {
        type: ButtonTypes.PRIMARY,
        symbol: IconSymbols.Plus
      },
      disabledWhenNoItemSelected: false,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.review,
      label: I18n.t("phrases.review"),
      type: "uiAction",
      onAction: ev => model.showProjectStakeholderConfirmReviewModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.CommentPencil
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.email,
      label: I18n.t("phrases.email"),
      type: "uiAction",
      onAction: ev => model.showEmailsModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Mail
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.delete,
      label: I18n.t("phrases.delete"),
      type: "uiAction",
      onAction: ev => model.showProjectStakeholderConfirmDeleteModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Trash
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.link,
      label: (
        <>
          <Icon symbol={IconSymbols.Link} size={UiSizes.MD} />
          <Icon symbol={IconSymbols.ChevronDown} size={UiSizes.SM} />
        </>
      ),
      type: "uiAction",
      componentProps: {
        type: ButtonTypes.LINK,
        className: "p-1"
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON,
      children: [
        {
          id: GridLinkActionEnum.linkImpacts,
          label: I18n.t("entities.impacts"),
          type: "uiAction",
          onAction: ev => model.showLinkToImpacts(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkActions,
          label: I18n.t("entities.actionOwned"),
          type: "uiAction",
          onAction: ev => model.showLinkToActions(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        }
      ]
    },
    {
      id: GridActionEnum.bulkEdit,
      label: I18n.t("phrases.bulkEdit"),
      type: "uiAction",
      onAction: ev => model.showBulkEditModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Edit3
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.export,
      label: I18n.t("phrases.export"),
      type: "uiAction",
      onAction: ev => model.exportRows(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Download
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: "devider",
      label: "",
      type: "devider",
      onAction: ev => {},
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.textWrap,
      label: I18n.t("phrases.textWrap"),
      type: "uiAction",
      onAction: ev => {
        model.textWrapAddon.toggleTextWrap();
        model.generateActions();
      },
      componentProps: {
        type: model.textWrapAddon.isWrappedText ? ButtonTypes.PRIMARY : ButtonTypes.OUTLINE_PRIMARY,
        symbol: IconSymbols.TextWrap
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.clearFilters,
      label: I18n.t("phrases.clearFilters"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.filterStoreAddon.clearFilters();
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.ClearFilter,
        isDisabled: !model.isFilterChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.resetColumns,
      label: I18n.t("phrases.resetColumns"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.columnStateAddon.resetColumns();
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.MonitorBack,
        isDisabled: !model.isColumnStateChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    }
  ];
};
